import { get } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import { GetMaxDecimalWithStaticMinValidation, Required } from '../../../../../../../lib/validation/ValidationTypes';
import { mapindexbyPath } from '../../../../../../../utils/formStruc';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = Schema.attributes;

const ProjektergebnisseAbschlussEmob: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	return (
		<>
			<ApplicationHeading
				title='Beschreibung der erzielten Projektergebnisse'
				description='Beschreibung und Bewertung der erreichten Projektergebnisse im Vergleich zu den im Antrag formulierten Zielen (SOLL-/IST-Abgleich). Ggf. ergänzende Darstellung zusätzlicher, über die Planung hinausgehender Ergebnisse.'
			/>
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};

export default ProjektergebnisseAbschlussEmob;

export const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [{ ...P.Abschlussbericht_Elektro_0117858833_se_Projektergebnisse_Block_1, type: 'componentTable' }],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

const customformStruc = (): FormStrucItem[] => [
	{
		fields: [
			P.Abschlussbericht_Elektro_0117858833_se_Projektergebnisse_Block_1.schema.attributes.Zelle_1,
			P.Abschlussbericht_Elektro_0117858833_se_Projektergebnisse_Block_1.schema.attributes.Zelle_2,
			P.Abschlussbericht_Elektro_0117858833_se_Projektergebnisse_Block_1.schema.attributes.Zelle_3,
			P.Abschlussbericht_Elektro_0117858833_se_Projektergebnisse_Block_1.schema.attributes.Zelle_4,
			P.Abschlussbericht_Elektro_0117858833_se_Projektergebnisse_Block_1.schema.attributes.Zelle_5,
			{
				...P.Abschlussbericht_Elektro_0117858833_se_Projektergebnisse_Block_1.schema.attributes.Zelle_6,
				validation: [{ validateFunction: Required }, { validateFunction: GetMaxDecimalWithStaticMinValidation, params: [100] }],
			},
		],
	},
];

export function getFormStrucProjektergebnisseAbschlussEmob(application: any): FormStrucItem[] {
	let result: any = [];
	const componentTableLength = get(application, P.Abschlussbericht_Elektro_0117858833_se_Projektergebnisse_Block_1.path, []).length;
	const parentObject = P.Abschlussbericht_Elektro_0117858833_se_Projektergebnisse_Block_1;

	for (let i = 0; i < componentTableLength; i++) {
		mapindexbyPath(customformStruc(), i, parentObject).forEach((element: any) => {
			result.push(element);
		});
	}

	return result;
}
